import { mdiEyeOff } from '@mdi/js'
import Icon from '@mdi/react'

const EyeOff = (props) => (
    <Icon
        data-testid="IconButton__EyeOffButton"
        aria-label="Hide Password"
        path={mdiEyeOff}
        size={1}
        {...props}
    />
)

export default EyeOff
